import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON, isOk, authReq} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function transfersSetList(transfers) {
  return {
    type: constants.TRANSFERS_SET,
    transfers
  };
}

export function transfersIncomingSetList(transfers) {
  return {
    type: constants.TRANSFERS_INCOMING_SET,
    transfers
  };
}

export function transfersPendingSetList(transfers) {
  return {
    type: constants.TRANSFERS_PENDING_SET,
    transfers
  };
}

export function transfersSetLocations(locations) {
  return {
    type: constants.TRANSFERS_SET_LOCATIONS,
    locations
  };
}

export function transfersOpenSetList(transfers) {
  return {
    type: constants.TRANSFERS_OPEN_SET,
    transfers
  };
}

export function transfersClosedSetList(transfers) {
  return {
    type: constants.TRANSFERS_CLOSED_SET,
    transfers
  };
}

export function transfersClosedSetLgdList(transfers) {
  return {
    type: constants.TRANSFERS_CLOSED_SET_LGD,
    transfers
  };
}

export function transfersSetCounts(counts) {
  return {
    type: constants.TRANSFERS_SET_COUNTS,
    counts
  };
}

export function transfersSetLgdCounts(counts) {
  return {
    type: constants.TRANSFERS_SET_LGD_COUNTS,
    counts
  };
}

export function transfersUpdateClosedPage(page) {
	return {
    type: constants.TRANSFERS_SET_CLOSED_PAGE,
    page
  };
}

/******************************
*******  Asynchronous  ********
******************************/


export function transfersFetch(isLgd = false) {
	return dispatch => {
		let url = `${api.API_URL}${endpoint.TRANSFERS_FETCH}`;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function transfersIncomingFetch(isLgd = false) {
	return dispatch => {
		let url = `${api.API_URL}${endpoint.TRANSFERS_INCOMING_FETCH}`;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function transferApprove(transfer_data) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_APPROVE;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(transfer_data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function transferReject(transfer_data) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_REJECT;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(transfer_data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function transferApproveLocal(transfer_data) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_APPROVE_LOCAL;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(transfer_data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function transferRejectLocal(transfer_data) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_REJECT_LOCAL;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(transfer_data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function transferPending(transfer_data) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_PENDING;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(transfer_data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function transferCheckDiamond(sku) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_CHECK_DIAMOND + '?sku=' + sku;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function transferEditRequest(edit_data) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_EDIT;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(edit_data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function fetchLocations() {
	return dispatch => {
		let url = api.API_URL + endpoint.LOCATIONS_FETCH;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function transferAddTransfer(edit_data) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_ADD;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(edit_data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function transferMarkShipped(ship_data) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_SHIP;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(ship_data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function transfersCountFetch(isLgd = false) {
	return dispatch => {
		let url = `${api.API_URL}${endpoint.TRANSFERS_COUNT}${isLgd ? '?lgd=1' : ''}`;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function transfersOpenFetch(isLgd = false) {
	return dispatch => {
		let url = `${api.API_URL}${endpoint.TRANSFERS_OPEN_FETCH}`;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function transfersClosedFetch(pageNum = 1, isLgd = false) {
	return dispatch => {
		let url = `${api.API_URL}${endpoint.TRANSFERS_CLOSED_FETCH}?page=${pageNum}${isLgd ? '&lgd=1' : ''}`;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function transferMarkCancelled(ship_data) {
	return dispatch => {
		let url = api.API_URL + endpoint.TRANSFERS_CANCEL;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(ship_data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function transferFetchDiamondById(diamondId) {
  return dispatch => {
    let url = api.DIAMOND_API + endpoint.PRODUCT_DIAMOND_BY_ID + '?id=' + diamondId;
    return fetch(url, {
      method: 'get',
      headers: api.HEADERS
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}